define( [ 'utility' ], function run( utility ) {
	'use strict';

	var mProductNavigationFn = {

		init : function( elm ) {
			if ( !elm.classList.contains( 'js-m-product-navigation' ) ) {
				elm.classList.add( 'js-m-product-navigation' );

				elm.mProductNavigation = {}; // Setup mProductNavigation object

				// Get config data
				elm.mProductNavigation.config = utility.getData( elm );

				// Find all control element in the page
				elm.mProductNavigation.control = elm.querySelector( '.m-product-navigation__heading' );
				elm.mProductNavigation.content = elm.querySelector( '.m-product-navigation__content' );

				mProductNavigationFn.setupControl( elm );

				elm.mProductNavigation.close = function close() {
					// If the section is open then close it
					if ( elm.mProductNavigation.controlLink.getAttribute( 'aria-expanded' ) === 'true' ) {
						mProductNavigationFn.toggleSelection( elm );
					}
				};
				elm.mProductNavigation.open = function open( scrollTo ) {
					var scrollParent,
						moveTo;

					if ( scrollTo ) {
						mProductNavigationFn.toggleSelection( elm, true );

						scrollParent = utility.scrollParent( elm.mProductNavigation.control );
						moveTo = elm.mProductNavigation.control.offsetTop - scrollParent.offsetTop;

						scrollParent.scrollTo( 0, moveTo );
					} else {
						mProductNavigationFn.toggleSelection( elm, true );
					}
				};
			}

			return elm.mProductNavigation;
		},

		setupControl : function( elm ) {
			var controlId = elm.mProductNavigation.control.getAttribute( 'id' ),
				autoId = utility.makeId( 'productNav' );

			utility.wrapInner( elm.mProductNavigation.control, 'button', 'm-product-navigation__control' );
			elm.mProductNavigation.controlLink = elm.mProductNavigation.control.querySelector( '.m-product-navigation__control' );
			if ( controlId ) {
				autoId = controlId + '-productNav';
			}

			utility.setAttributes( elm.mProductNavigation.controlLink, {
				type : 'button',
				'aria-controls' : autoId,
				'aria-expanded' : 'false',
			});

			elm.mProductNavigation.control.nextElementSibling.style.display = 'none';
			utility.setAttributes( elm.mProductNavigation.control.nextElementSibling, {
				id : autoId,
				'aria-hidden' : 'true',
			});

			// Add a click event to the control to open the associated element
			elm.mProductNavigation.controlLink.addEventListener( 'click', function listener( e ) {
				e.preventDefault();

				mProductNavigationFn.toggleSelection( elm );
			});
		},

		toggleSelection : function( elm, open ) {
			var parentId,
				toggleVariant = 'toggle';

			if ( !elm.mProductNavigation.controlLink.classList.contains( 'is-animating' ) ) {
				elm.mProductNavigation.controlLink.classList.add( 'is-animating' );

				parentId = elm.mProductNavigation.control.getAttribute( 'id' );

				if ( parentId ) {
					utility.updateHistory( '#' + parentId );
				}

				if ( elm.mProductNavigation.control.classList.contains( 'is-visible' ) && !open ) {
					elm.mProductNavigation.control.classList.remove( 'is-visible' );
				} else {
					elm.mProductNavigation.control.classList.add( 'is-visible' );
				}

				if ( open ) {
					toggleVariant = 'down';
				}

				utility.slideToggle( elm.mProductNavigation.control.nextElementSibling, FRAMEWORK.timings.current.t500ms, {
					variant : toggleVariant,
					callback : function() {
						if ( open ) {
							elm.mProductNavigation.controlLink.setAttribute( 'aria-expanded', 'true' );
							elm.mProductNavigation.content.setAttribute( 'aria-hidden', 'false' );
						} else {
							elm.mProductNavigation.controlLink.setAttribute( 'aria-expanded', elm.mProductNavigation.controlLink.getAttribute( 'aria-expanded' ) === 'true' ? 'false' : 'true' );
							elm.mProductNavigation.content.setAttribute( 'aria-hidden', elm.mProductNavigation.controlLink.getAttribute( 'aria-expanded' ) === 'true' ? 'false' : 'true' );
						}
						elm.mProductNavigation.controlLink.classList.remove( 'is-animating' );

						utility.trigger( window, 'refresh' );
					},
				});
			}
		},
	};

	return {
		initInstance : function( elm ) {
			return mProductNavigationFn.init( elm );
		},
	};
});
